"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterWrapper = exports.MobileDetailsMessage = exports.DetailsMessage = exports.ErrorMessage = exports.ActionWrapper = exports.InputWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../themes/colors");
const breakpoints_1 = require("../themes/breakpoints");
const verse_1 = __importDefault(require("../themes/verse"));
exports.InputWrapper = styled_components_1.default.div `
  ${({ theme, error, disabled, hasDropdown }) => (0, styled_components_1.css) `
    position: relative;
    display: grid;
    overflow: hidden;

    box-sizing: border-box;
    ${hasDropdown
    ? (0, styled_components_1.css) `
          grid-template-areas: 'input action select' 'message message message';
          grid-template-columns: 4fr auto auto;
        `
    : (0, styled_components_1.css) `
          grid-template-areas: 'input action' 'message message';
          grid-template-columns: 4fr auto;
        `}
    align-items: center;
    background: ${verse_1.default.palette.input.background.default};
    border: ${theme.border.style}
      ${error
    ? verse_1.default.palette.input.border.error
    : verse_1.default.palette.input.border.default};
    border-radius: ${theme.border.radius.small};

    // SelectModal
    & > #input-dropdown {
      grid-area: select;
      border: none;
      padding: 0;
      background: transparent !important;

      // arrow down
      & > svg {
        margin: 0 21px 0 9px;
      }
    }

    ${!disabled &&
    !error &&
    (0, styled_components_1.css) `
      &:hover {
        border: 1px solid ${colors_1.colors.shade70};
      }
    `}

    ${!disabled &&
    (0, styled_components_1.css) `
      &:active,
      &:focus-within {
        border: 2px solid
          ${error
        ? verse_1.default.palette.input.border.error
        : verse_1.default.palette.input.border.active};
        margin: -1px;
      }
    `}

		${disabled &&
    (0, styled_components_1.css) `
      background: ${verse_1.default.palette.input.background.disabled};
      border: ${verse_1.default.border.style} ${verse_1.default.palette.input.border.disabled};
      & > input {
        color: ${verse_1.default.palette.input.text.disabled};
      }

      & > svg {
        color: ${colors_1.colors.shade40};
      }
    `}
  `}
`;
exports.ActionWrapper = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
    grid-area: action;
    box-sizing: border-box;
    border: 0px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;

    & > button {
      max-height: ${theme.spacing.unit * 3}px;
      font-size: 14px;
      padding: 0 ${theme.spacing.unit * 2}px;
    }
  `}
`;
exports.ErrorMessage = styled_components_1.default.div `
  grid-area: message;
  padding: 9px 20px;
  background-color: ${colors_1.colors.red25};
  color: ${colors_1.colors.white};
  font-size: 12px;
`;
exports.DetailsMessage = styled_components_1.default.div `
  ${({ theme, disabled }) => (0, styled_components_1.css) `
    grid-area: message;
    padding: 9px 20px;
    background-color: ${colors_1.colors.verseNavBlue};
    color: ${colors_1.colors.shade80};
    font-size: 12px;

    ${disabled &&
    (0, styled_components_1.css) `
      background-color: ${colors_1.colors.verseNavBlue};
      color: ${theme.palette.input.text.disabled};
    `}
  `}
`;
exports.MobileDetailsMessage = styled_components_1.default.div `
  ${({ theme, disabled }) => (0, styled_components_1.css) `
    grid-area: message;
    padding: 9px 20px;
    background-color: ${colors_1.colors.verseNavBlue};
    color: ${colors_1.colors.shade80};
    font-size: 12px;

    ${disabled &&
    (0, styled_components_1.css) `
      background-color: ${colors_1.colors.verseNavBlue};
      color: ${theme.palette.input.text.disabled};
    `}

    ${breakpoints_1.media.sm `
			display: none;
		`}
  `}
`;
exports.CharacterWrapper = styled_components_1.default.div `
  ${({ theme, hasSubtext }) => (0, styled_components_1.css) `
    grid-area: input;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: ${hasSubtext
    ? `${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 2}px`
    : `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`};
    // input
    & > input {
      grid-area: input;
      width: 100%;
      background: transparent;
      border: none;
      color: ${theme.palette.text.default};
      text-overflow: ellipsis;

      border-radius: ${theme.border.radius.small};
      outline: none;

      font-weight: normal;
      box-sizing: border-box;
      font-size: 18px;
      font-weight: 600;

      &::placeholder {
        color: ${verse_1.default.palette.input.text.hover};
      }

      &::placeholder:disabled {
        color: ${verse_1.default.palette.input.text.disabled};
      }
    }
    & > div {
      color: ${verse_1.default.palette.text.secondary};
    }
  `}
`;
//# sourceMappingURL=styled.js.map